import React from "react";
import LazyImage from "../../common/LazyImage";
import {
  formatTime,
  formatDate,
  formatSlots,
  getFacilityImage,
  getStatusMeta,
} from "./userAccountUtils";

const BookingRow = ({
  booking,
  showCancel,
  onCancel,
  compact = false,
}) => {
  const imageSrc = getFacilityImage(booking.facility_image);
  const status = getStatusMeta(booking.status);
  const courtLabel = booking.courtName || booking.court || "Court";
  const location =
    booking.location ||
    [booking.address, booking.city].filter(Boolean).join(", ") ||
    null;

  return (
    <article className="ua-booking">
      <div
        className={`ua-booking__media ${
          !imageSrc ? "ua-booking__media--placeholder" : ""
        }`}
      >
        {imageSrc ? (
          <LazyImage src={imageSrc} alt={booking.facility || "Venue"} />
        ) : (
          <i className="fa-solid fa-building" aria-hidden="true" />
        )}
      </div>

      <div className="ua-booking__body">
        <h3 className="ua-booking__title">
          {booking.facility || "Venue"}
          <span className="ua-booking__court"> · {courtLabel}</span>
        </h3>
        <ul className="ua-booking__meta">
          <li>
            <i className="fa-regular fa-calendar" aria-hidden="true" />
            {formatDate(booking.date)}
          </li>
          <li>
            <i className="fa-regular fa-clock" aria-hidden="true" />
            {formatSlots(booking.slots, formatTime)}
          </li>
          {!compact && location ? (
            <li>
              <i className="fa-solid fa-location-dot" aria-hidden="true" />
              {location}
            </li>
          ) : null}
        </ul>
      </div>

      <div className="ua-booking__aside">
        {booking.payment != null || booking.price != null ? (
          <span className="ua-booking__price">
            ₹{booking.payment ?? booking.price ?? "0"}
          </span>
        ) : null}
        <span className={`ua-badge ua-badge--${status.tone}`}>
          <i className={`fa-solid ${status.icon}`} aria-hidden="true" />
          {status.label}
        </span>
        {showCancel ? (
          <button
            type="button"
            className="ua-btn ua-btn--danger ua-btn--sm"
            onClick={() => onCancel?.(booking.bookingId)}
          >
            Cancel
          </button>
        ) : null}
      </div>
    </article>
  );
};

export default BookingRow;
